import { typographyToCss } from 'shared/lib/mui';
import styled from 'styled-components';

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(5)};

  width: 100%;
  max-width: 50rem;
  padding: ${({ theme }) => theme.spacing(6)};

  border-radius: ${({ theme }) => theme.spacing(4)};
  background: ${({ theme }) => theme.palette.common.white};
  box-shadow: ${({ theme }) => theme.shadowBox.contentBlock};
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing(2)};
`;

export const Badge = styled.span`
  display: inline-flex;
  flex-shrink: 0;

  font-size: 2.4rem;
  line-height: 62.5%;
`;

export const Plans = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(3)};
`;

export const PriceNotice = styled.div`
  display: flex;
  align-items: center;
  ${({ theme }) => typographyToCss(theme.typography.caption)};

  margin: 0;
  padding-left: 4px;

  color: ${({ theme }) => theme.palette.warning.main};
`;

export const PriceNoticeBadge = styled.div`
  width: 0.6rem;
  height: 0.6rem;
  margin-right: ${({ theme }) => theme.spacing(1.5)};

  border-radius: 50%;
  background: currentColor;
`;

export const PriceNoticeLink = styled.a`
  color: inherit;
  text-decoration: underline;
  text-underline-offset: 0.2em;
  margin-left: 3px;
`;

export const CardFooter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(3)};
`;

export const Disclaimer = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.body2)};

  color: ${({ theme }) => theme.palette.text.secondary};
  text-align: center;
`;
